const PlaceholderCard = ({ botName, botPicture }) => (
  //   <div className="animate-pulse">
  <div className="cursor-pointer">
    <div className="bg-gray-300  w-full rounded-md">
      <img src="/img/logo/i-5.png" alt="Logo" />
    </div>
    <div className="space-y-2 mt-2">
      <p className="text-xl text-center">{botName}</p>
      {/* <div className="h-4 w-1/2 rounded"></div> */}
    </div>
  </div>
);

export default PlaceholderCard;
